import AsyncAutocomplete from '@components/v2/form/AsyncAutocomplete/AsyncAutocomplete';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import LangEnum from '../../lang/LangEnum';
import useTeceoStyles from '../../useTeceoStyles';
import { Collection } from '../collections/collections.types';
import { useTranslation } from '../translation/TranslationContext';

type OrderCollectionAutocompleteProps = {
  value?: Collection;
  onChange: (collection?: Collection) => void;
  label?: string;
};

const OrderCollectionAutocomplete = ({
  value,
  onChange,
  label,
}: OrderCollectionAutocompleteProps) => {
  const { classes: teceoClasses } = useTeceoStyles();
  const { translate } = useTranslation();

  return (
    <AsyncAutocomplete<Collection>
      label={label ?? translate(LangEnum.GLOBAL_ORDER_COLLECTION)}
      value={value?.id ?? null}
      initialData={value ? [value] : undefined}
      source={{ url: 'collections', queryField: 'name', limit: 20 }}
      getOptionLabel={(collection) => `${collection.code} - ${collection.name}`}
      renderOption={(collection) => (
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          <Typography className={teceoClasses.lowercase}>{collection.name}</Typography>
          <Typography className={teceoClasses.lowercase} variant="body2" color="textSecondary">
            ({collection.code})
          </Typography>
        </Stack>
      )}
      onChange={(_, options) => onChange(options[0] ?? undefined)}
    />
  );
};

export default OrderCollectionAutocomplete;
